import Vue from 'vue';
import Router from 'vue-router';
import Map from '@/components/Map.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Map',
      component: Map,
    },
  ],
})
